import { Component } from '@angular/core';
import { APP_VERSION } from '../../../environments/version';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss'
})
export class FooterComponent {
  versaoApp = APP_VERSION;
  isLoading = false;

  onLinkClick() {
    this.isLoading = true;
    setTimeout(() => {
      this.isLoading = false;
    }, 2000);
  }
}
